module.exports = __webpack_public_path__ + "static/media/xpg-blackJack.5ea8fb1e.png";